import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RawHtml } from "../../../lib/ReactUtils";
import React from "react";
import USER_ACTIONS from "../../UserActions";
import { createUseStyles } from "react-jss";
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { mergeDeepRight } from "ramda";
import widgetIconStyles from "./WidgetIconStyles.js";

const useStyles = createUseStyles((theme) =>
  mergeDeepRight(widgetIconStyles(theme), {
    widgetIcon: {
      position: "fixed",
      height: "32px",
      bottom: "50%",
      right: "-98px",
      width: "230px",
      transform: "rotate(-90deg)",
      borderRadius: "31px",
      animationName: "$slide-right",
      zIndex: "99",
    },
    innerInterface: {
      display: "flex",
      margin: "auto",
    },
    messageText: {
      fontSize: "14px",
      lineHeight: "27px",
      margin: "3px 3px 3px 10px",
    },
    notificationCircle: {
      top: "-10px",
      right: "-10px",
    },
    "@keyframes slide-right": {
      "0%": { opacity: "0", transform: "translateX(200px)" },
      "50%": { opacity: "1", transform: "translateX(200px) rotate(-90deg)" },
      "100%": { opacity: "1", transform: "translateX(0) rotate(-90deg)" },
    },
  })
);

export default ({ addUserAction, customWidgetImage, text }) => {
  const styles = useStyles();
  return (
    <button
      onClick={() => addUserAction(USER_ACTIONS.FAB_BUTTON)}
      className={styles.widgetIcon}
    >
      <div className={styles.innerInterface}>
        {customWidgetImage ? (
          <RawHtml tag={"span"}>{customWidgetImage}</RawHtml>
        ) : (
          <FontAwesomeIcon
            icon={faComment}
            aria-label="Click to open virtual assistant"
            title="Click to open virtual assistant"
          />
        )}
        <div className={styles.messageText}>{text}</div>
      </div>
    </button>
  );
};
